import React from "react"
import { Link } from "gatsby"
import MarketStats, { EFooterLayout, MarketStatsMarket, MarketStatsStat } from "@organic-return/foundation-react/src/components/MarketStats/MarketStats"
import { BackgroundImage } from "@organic-return/foundation-react/src/components/Media"
import { EWsrvTransform } from "@organic-return/foundation-react/src/lib"

export const ManualStats = ({ module, page }) => {
    const fields = module.customFields

    let marketStats: MarketStatsStat[] = []
    fields.statsSectionOneText && fields.statsSectionOneTitle && marketStats.push({ label: fields.statsSectionOneText, value: fields.statsSectionOneTitle })
    fields.statsSectionTwoText && fields.statsSectionTwoTitle && marketStats.push({ label: fields.statsSectionTwoText, value: fields.statsSectionTwoTitle })
    fields.statsSectionThreeText && fields.statsSectionThreeTitle && marketStats.push({ label: fields.statsSectionThreeText, value: fields.statsSectionThreeTitle })
    fields.statsSectionFourText && fields.statsSectionFourTitle && marketStats.push({ label: fields.statsSectionFourText, value: fields.statsSectionFourTitle })
    fields.statsSectionFiveText && fields.statsSectionFiveTitle && marketStats.push({ label: fields.statsSectionFiveText, value: fields.statsSectionFiveTitle })
    fields.statsSectionSixText && fields.statsSectionSixTitle && marketStats.push({ label: fields.statsSectionSixText, value: fields.statsSectionSixTitle })

    let markets: MarketStatsMarket[] = []
    marketStats.length > 0 && markets.push({ marketLabel: 'label', marketData: marketStats })

    let links: any[] = []
    if (fields.cTALink?.href) {
        fields.cTALink?.href && links.push({
            href: fields.cTALink.href,
            label: fields.cTALink.text,
        })
    }

    const stats = (
        <MarketStats
            markets={markets}
            title={fields.title}
            className="mx-auto w-full max-w-screen-2xl"
            links={links}
            linkFunc={props => (
                <Link to={props.href ?? ""} className={props.className} key={props.key}>
                    <>{props.children}</>
                </Link>
            )}
            footerLayout={EFooterLayout.centered}
            linkAsButton={false}
        />
    )

    if (!markets.length) return <></>
    return (
        <>
            {fields.backgroundImage?.url && (
                <BackgroundImage
                    src={fields.backgroundImage?.url}
                    className={`manual-stats text-white flex justify-center w-full py-10 h-fit md:min-h-screen`}
                    sizesAndAspect={[
                        {
                            width: 420,
                            aspect: EWsrvTransform.cover2x6,
                        },
                        {
                            media: "min-width:420px",
                            width: 640,
                            aspect: EWsrvTransform.cover2x6,
                        },
                        {
                            media: "min-width:640px",
                            width: 768,
                            aspect: EWsrvTransform.cover3x2,
                        },
                        {
                            media: "min-width:768px",
                            width: 1024,
                            aspect: EWsrvTransform.cover3x2,
                        },
                        {
                            media: "min-width:1024px",
                            width: 1280,
                            aspect: EWsrvTransform.cover16x9,
                        },
                        {
                            media: "min-width:1280px",
                            width: 1440,
                            aspect: EWsrvTransform.cover16x9,
                        },
                    ]}
                >
                    {stats}
                </BackgroundImage>
            )}
            {!fields.backgroundImage?.url && (
                <div className={`manual-stats text-white flex justify-center w-full py-10 h-fit md:min-h-screen`}>
                    {stats}
                </div>
            )}
        </>
    )
}

export default ManualStats